'use client';

import { FC, useEffect, useState } from 'react';
import Cookies from 'universal-cookie';

import { GetStartedMicrocopyProps } from 'src/checkout/sections/GetStarted/GetStarted';
import { Button } from 'src/general/components/Button/Button';
import { LocationObject } from 'src/general/components/SetLocationPopup/EnterLocationScreen/SetLocation/SetLocation.types';
import { SetLocationPopup } from 'src/general/components/SetLocationPopup/SetLocationPopup';
import { pushToDataLayer } from 'src/utils/pushToDataLayer';

interface Props {
  microcopy: GetStartedMicrocopyProps;
}
const LOCATION_COOKIE_KEY = 'deliveryLocation';
const COOKIE_EXPIRY = 30 * 24 * 60 * 60 * 1000;

export const GetStartedLocationModal: FC<Props> = ({ microcopy }) => {
  const cookies = new Cookies();
  const locationRaw = cookies.get(LOCATION_COOKIE_KEY);
  const [location, setLocation] = useState<LocationObject | undefined>(locationRaw ?? undefined);
  const [isOpen, setIsOpen] = useState(false);
  const { deliveryLink } = microcopy;

  useEffect(() => {
    if (location) {
      const expires = new Date(new Date().getTime() + COOKIE_EXPIRY);
      cookies.set(LOCATION_COOKIE_KEY, location, {
        path: '/',
        secure: process.env.NODE_ENV === 'production',
        expires,
      });
    }
  }, [location]);

  const onAction = () => {
    setIsOpen(true);
    pushToDataLayer({ event: 'set_handover_location_initiate' });
  };

  return (
    <>
      <Button variant="link" onClick={onAction} data-testid="set-location-modal-button">
        {deliveryLink}
      </Button>
      <SetLocationPopup
        open={isOpen}
        location={location}
        onClose={() => setIsOpen(false)}
        onChange={setLocation}
        microcopy={microcopy}
        handleEditLocation={() => {
          setLocation(undefined);
          pushToDataLayer({ event: 'set_handover_location_edit_location' });
        }}
      />
    </>
  );
};
